import getApiBaseUrl from '@/utils/getBaseUrl';
import { useMutation } from '@tanstack/react-query';

interface Payload {
  agentName: string;
  agentEmailAddress: string;
  clientName: string;
  clientEmailAddress: string;
  propertyAddress: string;
  propertyId: string;
  states: string[];
  additionalInfo?: string;
}

export default function useDisclosureStateEmail() {
  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/common/email/disclosure-states`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to send disclosure email: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
  });
}
